import stylesheet from './Input.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

export abstract class NXTBaseInput<ValueType = string> extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get icon(): string {
        return this.getAttribute('icon');
    }

    public abstract get value(): ValueType;

    protected renderLabel(): HTMLElement {
        const label = document.createElement('div');
        label.classList.add('input-label');
        label.innerHTML = `<slot name="label"></slot>`;
        return label;
    }

}
